import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DataTable, DeleteModal, Excel } from "CommonComponent";
import { fetchTasks, deleteTask, getTaskById, exportHandler } from "actions";
import AccessRights from "utils/AccessRights";
import { Columns, Header, Filter, AddUpdateTask } from "./component";
import { useLocation } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const Task = () => {
  let location = useLocation();
  const dispatch = useDispatch();
  const timeSheetTaskState = useSelector((s) => s.timeSheetTaskState);
  const session = useSelector((s) => s.session);

  const object_viewed_id = session?.current_page_permissions?.object_id || "";

  const [showAddUpdateModal, setShowAddUpdateModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [extraFiltersState, setExtraFiltersState] = useState({
    values: {},
  });

  useEffect(() => {
    if (
      session.current_page_permissions &&
      session.current_page_permissions.page_url === location.pathname
    ) {
      dispatch(fetchTasks({ ...extraFiltersState.values, object_viewed_id }));
    }
  }, [session.current_page_permissions]);

  useEffect(() => {
    if (timeSheetTaskState.redirectToList) {
      dispatch(fetchTasks({ ...extraFiltersState.values, object_viewed_id }));
    }
  }, [timeSheetTaskState.redirectToList]);

  useEffect(() => {
    if (timeSheetTaskState.showUpdateForm) {
      setIsEdit(true);
      setShowAddUpdateModal(true);
    } else {
      setIsEdit(false);
      setShowAddUpdateModal(false);
    }
  }, [timeSheetTaskState.showUpdateForm]);

  const handleAdd = () => {
    setIsEdit(false);
    setShowAddUpdateModal(true);
  };

  const handleEdit = (row) => {
    setSelectedRow(row);
    dispatch(getTaskById(row.id, "update", object_viewed_id));
  };

  const handleDelete = (row) => {
    setSelectedRow(row);
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    dispatch(deleteTask(selectedRow.id, object_viewed_id));
    setShowDeleteModal(false);
  };

  const getActions = (row) => (
    <div className="d-flex align-items-center gap-2">
      {AccessRights(session.current_page_permissions, "edit", row.created_by) &&
        row.is_deleted === "n" && (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`tooltip-edit-${row.id}`}>Edit</Tooltip>}
          >
            <img
              src="/assets/images/edit-icon.svg"
              alt="Edit"
              onClick={() => handleEdit(row)}
              style={{ cursor: "pointer", marginRight: "10px" }}
            />
          </OverlayTrigger>
        )}
      {AccessRights(
        session.current_page_permissions,
        "delete",
        row.created_by,
      ) &&
        row.is_deleted === "n" && (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`tooltip-delete-${row.id}`}>Delete</Tooltip>}
          >
            <img
              src="/assets/images/delete-icon.svg"
              alt="Delete"
              onClick={() => handleDelete(row)}
              style={{ cursor: "pointer" }}
            />
          </OverlayTrigger>
        )}
    </div>
  );

  const columns = Columns({ getActions, session });
  const rows = timeSheetTaskState.tasksList || [];

  const filterTable = () => {
    dispatch(fetchTasks({ ...extraFiltersState.values, object_viewed_id }));
  };

  const handleExport = () => {
    dispatch(
      exportHandler(
        "timesheet/tasks/export",
        extraFiltersState.values,
        object_viewed_id,
        "tasks.xlsx",
      ),
    );
  };

  return (
    <div className="wrapper-div">
      <Header
        onAdd={handleAdd}
        extraFilters={extraFiltersState.values}
        object_viewed_id={object_viewed_id}
      />

      {/* Bread crumb or Filter */}
      <div className="d-flex justify-content-end align-items-center pb-4 px-4 position-sticky top-70 bg-white z-1">
        <div className="d-flex align-items-center gap-3">
          <Excel handleExport={handleExport} />
        </div>
      </div>
      <Filter
        onFilter={filterTable}
        extraFiltersState={extraFiltersState}
        setExtraFiltersState={setExtraFiltersState}
      />
      <DataTable
        columns={columns}
        data={rows}
        serverSide={false}
        showSearch={false}
        className="table-container"
      />
      {showAddUpdateModal && (
        <AddUpdateTask
          show={showAddUpdateModal}
          onHide={() => setShowAddUpdateModal(false)}
          isEdit={isEdit}
          object_viewed_id={object_viewed_id}
        />
      )}
      {showDeleteModal && (
        <DeleteModal
          show={showDeleteModal}
          onHide={() => setShowDeleteModal(false)}
          onConfirm={confirmDelete}
          message="Are you sure you want to delete this task?"
        />
      )}
    </div>
  );
};

export default Task;
